module.exports = __webpack_public_path__ + "media/images/contest_banners/contests-5-banner@2x-6c094fe99ac226baeb0dc06d4e12cfb6.png";